<template>
  <client-only>
    <div v-if="isBannerVisible" cookie-name="cookieConsentViewed" class="fixed inset-0 bg-dark-grey opacity-50 z-40" />
    <div
      v-if="isBannerVisible"
      data-test-id="component-cookie-banner"
    >
      <SharedGenericBanner ref="cookieBanner" cookie-name="cookieConsentViewed" addon-class="fixed bottom-0 md:bottom-[48px] md:right-[48px] shadow-banner z-50 w-full md:w-[550px] md:rounded" bg-class="bg-white">
        <template #default="{close}">
          <div class="container items-center px-8">
            <p class="my-2 text-smaller font-medium md:text-display-5 leading-tight select-none" v-html="$messages('shared.cookie_banner')" />
            <p class="text-tiny md:text-smallest leading-tight select-none text-dusty-gray font-light" v-html="cookieMessage" />
            <div class="md:flex md:space-x-6 mt-8">
              <button
                type="button"
                class="w-full mb-tiny btn btn-black"
                @click="acceptCookie"
              >
                {{ $messages('shared.cookie_consent_accept') }}
              </button>
              <button
                type="button"
                class="w-full mb-tiny btn btn-black btn-black-outline"
                @click="declineCookie"
              >
                {{ $messages('shared.cookie_consent_decline') }}
              </button>
            </div>
          </div>
        </template>
      </SharedGenericBanner>
    </div>
  </client-only>
</template>

<script>
import { ESSENTIAL_COOKIENAMES } from '~/utils/constants'
export default {
  data () {
    return {
      cookieName: 'cookieConsentViewed',
      cookieConsent: 'cookieConsent',
      cookieMessage: '',
      isBannerVisible: !useCookie('cookieConsentViewed').value
    }
  },
  computed: {
    queryParameters () {
      if (this.$route.query) {
        return this.$route.query
      }
      return null
    }
  },
  created () {
    const link = this.$mRouter.getLocalRoute({ name: 'terms-of-use-slug', params: { slug: this.$i18n.locale === 'es' ? 'politica-de-privacidad' : 'privacy-policy' } }).href
    this.cookieMessage = this.$messages('shared.cookie_consent_message', { link, classes: 'font-medium' })
  },
  methods: {
    acceptCookie () {
      const cookieOptions = {
        maxAge: SEVEN_DAYS_IN_SECONDS
      }
      const cookie = useCookie(this.cookieName, { maxAge: SIXTY_DAYS_IN_SECONDS })
      cookie.value = true
      const consent = useCookie(this.cookieConsent, { maxAge: SIXTY_DAYS_IN_SECONDS })
      consent.value = 'accepted'

      const cookies = COOKIENAMES.map((name) => {
        return [name, this.queryParameters[name]]
      })

      cookies.forEach(([name, value = null]) => {
        if (this.queryParameters[name]) {
          value = this.queryParameters[name]
          localStorage.setItem(name, value)
        }
        if (value) {
          const c = useCookie(name, cookieOptions)
          c.value = value
        }
      })

      // FBC and FBP for Meta tracking. Backup for if the Meta Pixel fails to load.

      const timestamp = Date.now()

      const _fbc = useCookie('_fbc', cookieOptions)
      const fbclid = this.queryParameters.fbclid
      if (fbclid) {
        const fbctoken = `fb.1.${timestamp}.${fbclid}`
        _fbc.value = fbctoken
        localStorage.setItem('_fbc', fbctoken)
      }

      const _fbp = useCookie('_fbp', cookieOptions)
      if (!_fbp.value) {
        const randomNumber = Math.floor(Math.random() * 10000000000)
        const fbptoken = `fb.1.${timestamp}.${randomNumber}`
        _fbp.value = fbptoken
        localStorage.setItem('_fbp', fbptoken)
      }

      // TikTok, Google, and Microsoft tracking

      const tiktokTtclid = useCookie('tiktok_ttclid', cookieOptions)
      const ttclid = this.queryParameters.ttclid
      if (ttclid) {
        tiktokTtclid.value = ttclid
        localStorage.setItem('tiktok_ttclid', ttclid)
      }

      const googleGclid = useCookie('google_gclid', cookieOptions)
      const gclid = this.queryParameters.gclid
      if (gclid) {
        googleGclid.value = gclid
        localStorage.setItem('google_gclid', gclid)
      }

      const microsoftMsclkid = useCookie('microsoft_msclkid', cookieOptions)
      const msclkid = this.queryParameters.msclkid
      if (msclkid) {
        microsoftMsclkid.value = msclkid
        localStorage.setItem('microsoft_msclkid', msclkid)
      }
      this.$refs.cookieBanner.close()
      this.isBannerVisible = false
    },
    declineCookie () {
      const cookie = useCookie(this.cookieName, { maxAge: SIXTY_DAYS_IN_SECONDS })
      cookie.value = true
      const consent = useCookie(this.cookieConsent, { maxAge: SIXTY_DAYS_IN_SECONDS })
      consent.value = 'declined'
      this.deleteOldCookies()
      this.setLocalStorage('declined')
      this.$refs.cookieBanner.close()
      this.isBannerVisible = false
    },
    deleteOldCookies () {
      COOKIENAMES.forEach((name) => {
        const c = useCookie(name)
        c.value = null
      })
      EXTENTDEDCOOKIENAMES.forEach((name) => {
        const c = useCookie(name)
        c.value = null
      })
      const cookies = document.cookie.split('; ')
      for (let c = 0; c < cookies.length; c++) {
        const cookieName = cookies[c].split(';')[0].split('=')[0]

        console.log(cookies[c], 'outside if', cookieName)
        if (!ESSENTIAL_COOKIENAMES.includes(cookieName)) {

          const d = window.location.hostname.split('.')
          while (d.length > 0) {
            const cookieBase = encodeURIComponent(cookieName) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=/'
            document.cookie = cookieBase
            d.shift()
          }
        }
      }
    },
    setLocalStorage (consentValue) {
      const cookies = COOKIENAMES.map((name) => {
        return [name, this.queryParameters[name]]
      })

      cookies.forEach(([name, value = null]) => {
        if (this.queryParameters[name]) {
          value = this.queryParameters[name]
          localStorage.setItem(name, value)
        }
      })

      // TikTok, Google, and Microsoft tracking

      const ttclid = this.queryParameters.ttclid
      if (ttclid) {
        localStorage.setItem('tiktok_ttclid', ttclid)
      }

      const gclid = this.queryParameters.gclid
      if (gclid) {
        localStorage.setItem('google_gclid', gclid)
      }

      const msclkid = this.queryParameters.msclkid
      if (msclkid) {
        localStorage.setItem('microsoft_msclkid', msclkid)
      }
      // FBC and FBP for Meta tracking. Backup for if the Meta Pixel fails to load.

      const timestamp = Date.now()
      const fbclid = this.queryParameters.fbclid
      if (fbclid) {
        const fbctoken = `fb.1.${timestamp}.${fbclid}`
        localStorage.setItem('_fbc', fbctoken)
      }

      const _fbp = localStorage.getItem('_fbp')
      if (!_fbp) {
        const randomNumber = Math.floor(Math.random() * 10000000000)
        const fbptoken = `fb.1.${timestamp}.${randomNumber}`
        localStorage.setItem('_fbp', fbptoken)
      }
    }
  }
}
</script>
